export default class SetDefaultPricingForWorkTypeGroupError extends Error {

}
